(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["april-2026-promos"] && !Shopify.designMode) return;
  try {
    /* April 2026 cart promo banner
     - No cart mutations
     - Renders a static message inside Rebuy Smart Cart
     - Shows only when cart includes LIMITED or SIGNATURE reset variant
  */

  (() => {
    if (window.__AprilPromoBannerInit) return;
    window.__AprilPromoBannerInit = true;

    const TARGET_VARIANT_IDS = new Set([40517350064328, 41742830829768]);
    const MESSAGE = 'Your free gift is included with this reset.';

    class AprilPromoBanner {
      constructor() {
        this.rootEl = null;
        this.observer = null;
        this.renderTimeout = null;
        this.init = this.init.bind(this);
        this.render = this.render.bind(this);
        this.debouncedRender = this.debouncedRender.bind(this);
      }

      init() {
        document.addEventListener('rebuy:smartcart.ready', this.debouncedRender);
        document.addEventListener('rebuy:cart.change', this.debouncedRender);

        this.waitForSmartCart();
        this.observeCartChanges();
      }

      debouncedRender() {
        clearTimeout(this.renderTimeout);
        this.renderTimeout = setTimeout(() => {
          this.render();
        }, 50);
      }

      waitForSmartCart() {
        let attempts = 0;
        const maxAttempts = 50;

        const interval = setInterval(() => {
          attempts += 1;
          const anchor = this.getAnchorElement();

          if (anchor) {
            clearInterval(interval);
            this.render();
          }

          if (attempts >= maxAttempts) {
            clearInterval(interval);
          }
        }, 200);
      }

      getAnchorElement() {
        return (
          document.querySelector('ul[data-smartcart-items]') ||
          document.querySelector('.rebuy-widget.widget-type-cart.widget-display-popup .rebuy-cart__items-wrapper')
        );
      }

      observeCartChanges() {
        if (this.observer) {
          this.observer.disconnect();
        }

        this.observer = new MutationObserver(() => {
          if (this.rootEl && !document.body.contains(this.rootEl)) {
            this.debouncedRender();
            return;
          }

          this.debouncedRender();
        });

        this.observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }

      ensureRoot() {
        const anchor = this.getAnchorElement();
        if (!anchor) return null;

        if (!this.rootEl || !document.body.contains(this.rootEl)) {
          this.rootEl = document.createElement('div');
          this.rootEl.className = 'april-promo-banner';
          this.rootEl.setAttribute('data-april-promo-banner', 'true');
        }

        if (anchor.matches && anchor.matches('ul[data-smartcart-items]') && anchor.parentElement) {
          if (this.rootEl.parentElement !== anchor.parentElement || this.rootEl.nextElementSibling !== anchor) {
            this.rootEl.remove();
            anchor.before(this.rootEl);
          }
          return this.rootEl;
        }

        if (!anchor.contains(this.rootEl)) {
          if (anchor.firstChild) {
            anchor.insertBefore(this.rootEl, anchor.firstChild);
          } else {
            anchor.appendChild(this.rootEl);
          }
        }

        return this.rootEl;
      }

      removeRoot() {
        if (this.rootEl) {
          this.rootEl.remove();
          this.rootEl = null;
        }
      }

      async hasTargetResetInCart() {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          const items = Array.isArray(cart?.items) ? cart.items : [];

          return items.some((item) => TARGET_VARIANT_IDS.has(Number(item.id)));
        } catch (error) {
          console.error('April promo: cart check failed', error);
          return false;
        }
      }

      async render() {
        const shouldShow = await this.hasTargetResetInCart();
        if (!shouldShow) {
          this.removeRoot();
          return;
        }

        const root = this.ensureRoot();
        if (!root) return;

        const expectedHTML = `
          <div class="april-promo-banner__block" role="region" aria-label="April promo message">
            <p class="april-promo-banner__message">${MESSAGE}</p>
          </div>
        `.trim();

        if (root.innerHTML.trim() !== expectedHTML) {
          root.innerHTML = expectedHTML;
        }
      }
    }

    new AprilPromoBanner().init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["february-2026-promos"] && !Shopify.designMode) return;
  try {
    /* February Love promos for Rebuy Smart Cart
   Source of truth for promo detection: /cart.js (so _promo is always accurate)

   Block #1:
   - Show if cart has Signature/Limited/Deluxe
   - Hide once the Signature promo line exists (no "ADDED" state)
   - Button adds Signature (promo props)

   PDP Edition Selector Enhancement:
   - Modifies .custom-product-info-select-edition-info-wrapper on product pages
   - Adds promo label to Deluxe option: "Add for a free upgrade to limited edition"
   - Intercepts add-to-cart: when Deluxe is added, swaps it for Limited Edition with promo properties
*/
  (() => {
    const CONFIG = {
      // Variant IDs
      signatureVariantId: 41742830829768,
      limitedVariantId: 40517350064328,
      deluxeVariantId: 42429966778568,

      // Selling plan IDs by frequency (Deluxe -> Limited Edition)
      sellingPlanMap: {
        '692310999405': '692308935021', // 1 month
        '692311032173': '692308902253', // 2 months
        '692311064941': '692308967789', // 3 months
        '692311097709': '692309000557', // 4 months
      },

      // Promo line item property
      promoPropertyName: '_promo',
      promoPropertyValue: 'February Love',

      // Block #1 triggers if ANY of these are in cart
      triggerVariantIds: [41742830829768, 40517350064328, 42429966778568],

      // Optional: hide Block #1 if a Limited promo line already exists
      hideAddSignatureIfLimitedPromoExists: false,

      // DOM polling (wait for Smart Cart markup + correct <li>)
      domPollIntervalMs: 250,
      domPollMaxTicks: 80,

      // ✅ Debounced cart sync after every rebuy change (ensures _promo detection is correct after removals)
      cartSyncDebounceMs: 200,
    };

    class FebruaryLovePromos {
      constructor() {
        this.cart = null;

        this.isAddingSignature = false;

        this.rootEl = null;
        this.block1El = null;

        this.pdpLabelInjected = false;
        this.cartInterceptEnabled = false;
        this.formInterceptEnabled = false;

        this.domPoller = null;
        this.domPollTicks = 0;

        this.cartSyncTimer = null;
        this.isSyncingCart = false;

        this.onRebuyCartChange = this.onRebuyCartChange.bind(this);
      }

      mapLimitedSellingPlan(sellingPlanId) {
        if (!sellingPlanId) return sellingPlanId;
        return CONFIG.sellingPlanMap[String(sellingPlanId)] || sellingPlanId;
      }

      init() {
        document.addEventListener('rebuy:cart.change', this.onRebuyCartChange);

        // Initial sync
        this.syncCartFromServer().catch(() => {});

        // Poll DOM until smart cart exists
        this.startDomPolling();

        // Enhance PDP edition selector with promo label
        this.enhancePdpEditionSelector();

        // Intercept add-to-cart to swap Deluxe → Limited Edition with promo
        this.setupCartIntercept();

        // Intercept form submissions (collection page quick add)
        this.setupFormIntercept();
      }

      onRebuyCartChange() {
        // ✅ Always resync from Shopify cart endpoint so _promo is accurate after add/remove
        this.queueCartSync();
      }

      queueCartSync() {
        window.clearTimeout(this.cartSyncTimer);

        this.cartSyncTimer = window.setTimeout(() => {
          this.syncCartFromServer().catch((e) => {
            console.error('[Feb Love] /cart.js sync failed:', e);
          });
        }, CONFIG.cartSyncDebounceMs);
      }

      async syncCartFromServer() {
        if (this.isSyncingCart) return;
        this.isSyncingCart = true;

        try {
          const res = await fetch('/cart.js', { credentials: 'same-origin' });
          if (!res.ok) throw new Error('Failed to fetch /cart.js');
          this.cart = await res.json();
          this.render();
        } finally {
          this.isSyncingCart = false;
        }
      }

      startDomPolling() {
        if (this.domPoller) return;

        this.domPoller = window.setInterval(() => {
          this.domPollTicks += 1;

          if (this.domPollTicks > CONFIG.domPollMaxTicks) {
            window.clearInterval(this.domPoller);
            this.domPoller = null;
            return;
          }

          if (this.cart) this.render();

          // Also try to inject PDP label if not yet done
          if (!this.pdpLabelInjected) {
            this.enhancePdpEditionSelector();
          }

          const ul = this.getSmartCartItemsListEl();
          if (!ul) return;

          if (this.rootEl && ul.parentElement?.contains(this.rootEl)) {
            window.clearInterval(this.domPoller);
            this.domPoller = null;
          }
        }, CONFIG.domPollIntervalMs);
      }

      getSmartCartItemsListEl() {
        return document.querySelector('ul[data-smartcart-items]');
      }

      ensureRoot() {
        const ul = this.getSmartCartItemsListEl();
        if (!ul || !ul.parentElement) return null;

        if (!this.rootEl) {
          this.rootEl = document.createElement('div');
          this.rootEl.className = 'feb-love-promos';
          this.rootEl.setAttribute('data-feb-love-promos', 'true');
        }

        // ✅ Always place promos right BEFORE the UL (below the cart title)
        if (this.rootEl.parentElement !== ul.parentElement || this.rootEl.nextElementSibling !== ul) {
          this.rootEl.remove();
          ul.before(this.rootEl);
        }

        return this.rootEl;
      }

      getCartItems() {
        return Array.isArray(this.cart?.items) ? this.cart.items : [];
      }

      hasPromoLine(variantId) {
        return this.getCartItems().some((i) => {
          const isVariant = Number(i.variant_id) === Number(variantId);
          const isPromo = (i.properties?.[CONFIG.promoPropertyName] || '') === CONFIG.promoPropertyValue;
          return isVariant && isPromo;
        });
      }

      hasDiscountedSignature() {
        // Check if Signature variant has a discount with "LOVE" in the title
        return this.getCartItems().some((i) => {
          if (Number(i.variant_id) !== CONFIG.signatureVariantId) return false;
          const discounts = Array.isArray(i.discounts) ? i.discounts : [];
          return discounts.some((d) => d.title && d.title.toUpperCase().includes('LOVE'));
        });
      }

      getVisibilityFlags() {
        const items = this.getCartItems();

        const hasAnyTrigger = items.some((i) => CONFIG.triggerVariantIds.includes(Number(i.variant_id)));

        // Check for discounted Signature (via LOVE discount) instead of _promo property
        const signaturePromoAlreadyAdded = this.hasDiscountedSignature();
        const limitedPromoAlreadyAdded = this.hasPromoLine(CONFIG.limitedVariantId);

        // ✅ Hide block #1 entirely once promo signature line is gone/present based on _promo from /cart.js
        const shouldShowBlock1 =
          hasAnyTrigger &&
          !signaturePromoAlreadyAdded &&
          !(CONFIG.hideAddSignatureIfLimitedPromoExists && limitedPromoAlreadyAdded);

        return {
          shouldShowBlock1,
          signaturePromoAlreadyAdded,
        };
      }

      render() {
        const root = this.ensureRoot();
        if (!root || !this.cart) return;

        const { shouldShowBlock1 } = this.getVisibilityFlags();

        // ---------- Block #1 ----------
        if (shouldShowBlock1) {
          if (!this.block1El || !root.contains(this.block1El)) {
            this.block1El = document.createElement('div');
            this.block1El.className = 'feb-love-promos__block feb-love-promos__block--add';
            this.block1El.setAttribute('role', 'region');
            this.block1El.setAttribute('aria-label', 'February Love signature promo');
            root.appendChild(this.block1El);
          }

          // Since we hide the whole block when promo exists, no "ADDED" state needed
          const disabled = this.isAddingSignature;

          this.block1El.innerHTML = `
          <p class="feb-love-promos__message">Add a Signature Reset for 50% off!</p>
          <button
            type="button"
            class="feb-love-promos__btn"
            data-action="add-signature"
            ${disabled ? "disabled aria-disabled='true'" : ''}
            aria-label="Add Signature edition with February Love promo"
          >
            ADD
          </button>
        `;

          const btn = this.block1El.querySelector('[data-action="add-signature"]');
          btn?.addEventListener('click', () => this.handleAddSignature(), { once: true });
        } else {
          this.block1El?.remove();
          this.block1El = null;
        }
      }

      async postJson(endpoint, payload) {
        const res = await fetch(endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const text = await res.text().catch(() => '');
          throw new Error(`${endpoint} failed: ${res.status} ${text}`);
        }

        return res.json();
      }

      async handleAddSignature() {
        if (this.isAddingSignature) return;
        // Source of truth is /cart.js now, but this prevents extra clicks in same render cycle:
        if (this.hasPromoLine(CONFIG.signatureVariantId)) return;

        this.isAddingSignature = true;
        this.render();

        try {
          await this.postJson('/cart/add.js', {
            items: [
              {
                id: CONFIG.signatureVariantId,
                quantity: 1,
                properties: {
                  [CONFIG.promoPropertyName]: CONFIG.promoPropertyValue,
                },
              },
            ],
          });

          // Resync cart to update UI
          await this.syncCartFromServer();
        } catch (e) {
          console.error('[Feb Love] Add signature failed:', e);
        } finally {
          this.isAddingSignature = false;
          this.render();
        }
      }

      enhancePdpEditionSelector() {
        if (this.pdpLabelInjected) return;

        // Find the Deluxe edition option by data-edition attribute
        const deluxeOption = document.querySelector('.edition-option[data-edition="kroma-new-deluxe-5-day-lifestyle-reset"]');
        if (!deluxeOption) return;

        // Find the .edition-content container inside
        const editionContent = deluxeOption.querySelector('.edition-content');
        if (!editionContent || editionContent.querySelector('.feb-love-pdp-label')) return;

        // Create and inject the promo label
        const label = document.createElement('p');
        label.className = 'feb-love-pdp-label';
        label.textContent = 'Add for a free upgrade to Limited Edition!';

        // Append after the edition title
        editionContent.appendChild(label);
        this.pdpLabelInjected = true;

        console.log('[Feb Love] PDP promo label injected for Deluxe option');
      }

      setupCartIntercept() {
        if (this.cartInterceptEnabled) return;
        this.cartInterceptEnabled = true;

        const originalFetch = window.fetch;
        const mapLimitedSellingPlan = this.mapLimitedSellingPlan.bind(this);

        window.fetch = function (url, options) {
          // Check if this is an add-to-cart request
          const urlStr = typeof url === 'string' ? url : url?.url || '';
          const isCartAdd = urlStr.includes('/cart/add');

          if (isCartAdd && options?.body) {
            try {
              let body = options.body;

              // Parse the body if it's a string
              if (typeof body === 'string') {
                body = JSON.parse(body);
              }

              // Check if we're adding the Deluxe variant
              let modified = false;

              // Handle items array format
              if (Array.isArray(body.items)) {
                body.items = body.items.map((item) => {
                  if (Number(item.id) === CONFIG.deluxeVariantId) {
                    console.log('[Feb Love] Intercepting Deluxe add → swapping to Limited Edition with promo');
                    modified = true;
                    const swapped = {
                      ...item,
                      id: CONFIG.limitedVariantId,
                      properties: {
                        ...(item.properties || {}),
                        [CONFIG.promoPropertyName]: CONFIG.promoPropertyValue,
                      },
                    };
                    // Swap selling plan for any mapped Deluxe subscription frequency
                    const mappedSellingPlan = mapLimitedSellingPlan(item.selling_plan);
                    if (mappedSellingPlan !== item.selling_plan) {
                      swapped.selling_plan = mappedSellingPlan;
                      console.log('[Feb Love] Also swapping selling plan to Limited Edition subscription');
                    }
                    return swapped;
                  }
                  return item;
                });
              }

              // Handle single item format (id at root level)
              if (Number(body.id) === CONFIG.deluxeVariantId) {
                console.log('[Feb Love] Intercepting Deluxe add → swapping to Limited Edition with promo');
                modified = true;
                body.id = CONFIG.limitedVariantId;
                body.properties = {
                  ...(body.properties || {}),
                  [CONFIG.promoPropertyName]: CONFIG.promoPropertyValue,
                };
                // Swap selling plan for any mapped Deluxe subscription frequency
                const mappedSellingPlan = mapLimitedSellingPlan(body.selling_plan);
                if (mappedSellingPlan !== body.selling_plan) {
                  body.selling_plan = mappedSellingPlan;
                  console.log('[Feb Love] Also swapping selling plan to Limited Edition subscription');
                }
              }

              if (modified) {
                options = {
                  ...options,
                  body: JSON.stringify(body),
                };
              }
            } catch (e) {
              console.warn('[Feb Love] Could not parse cart add body:', e);
            }
          }

          return originalFetch.call(this, url, options);
        };

        console.log('[Feb Love] Cart intercept enabled: Deluxe → Limited Edition swap active');
      }

      setupFormIntercept() {
        if (this.formInterceptEnabled) return;
        this.formInterceptEnabled = true;

        // Track forms we're currently handling to prevent double-submission
        const handlingForms = new WeakSet();

        const handleDeluxeAdd = async (form) => {
          if (handlingForms.has(form)) return false;
          handlingForms.add(form);

          console.log('[Feb Love] Intercepting Deluxe form submission → swapping to Limited Edition with promo');

          // Get quantity
          const qtyInput = form.querySelector('input[name="quantity"]');
          const quantity = qtyInput ? Number(qtyInput.value) || 1 : 1;

          // Get selling plan if present
          const sellingPlanInput = form.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
          let sellingPlan = sellingPlanInput ? sellingPlanInput.value : null;

          // Swap selling plan for any mapped Deluxe subscription frequency
          const mappedSellingPlan = this.mapLimitedSellingPlan(sellingPlan);
          if (mappedSellingPlan !== sellingPlan) {
            sellingPlan = mappedSellingPlan;
            console.log('[Feb Love] Also swapping selling plan to Limited Edition subscription');
          }

          // Build the payload
          const payload = {
            items: [
              {
                id: CONFIG.limitedVariantId,
                quantity: quantity,
                properties: {
                  [CONFIG.promoPropertyName]: CONFIG.promoPropertyValue,
                },
              },
            ],
          };

          // Add selling plan if present
          if (sellingPlan) {
            payload.items[0].selling_plan = sellingPlan;
          }

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify(payload),
            });

            if (!res.ok) {
              throw new Error('Add to cart failed');
            }

            // Trigger cart update event for Rebuy/other cart drawers
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('rebuy:cart.change'));

            // Also try to open the cart drawer if it exists
            const cartDrawerTrigger = document.querySelector('[data-cart-drawer-trigger], [data-open-cart], .js-open-cart');
            if (cartDrawerTrigger) {
              cartDrawerTrigger.click();
            }

            console.log('[Feb Love] Successfully added Limited Edition with promo from collection page');
            return true;
          } catch (err) {
            console.error('[Feb Love] Form intercept add failed:', err);
            return false;
          } finally {
            handlingForms.delete(form);
          }
        };

        const isDeluxeForm = (form) => {
          if (!form || !form.matches('form[action*="/cart/add"]')) return false;
          const variantInput = form.querySelector('input[name="id"]');
          return variantInput && Number(variantInput.value) === CONFIG.deluxeVariantId;
        };

        // Intercept click on add-to-cart buttons (runs before form submit)
        document.addEventListener('click', async function (e) {
          const button = e.target.closest('button[type="submit"], input[type="submit"]');
          if (!button) return;

          const form = button.closest('form');
          if (!isDeluxeForm(form)) return;

          // Prevent the click from triggering form submission
          e.preventDefault();
          e.stopImmediatePropagation();

          await handleDeluxeAdd(form);
        }, true);

        // Also intercept form submissions as backup
        document.addEventListener('submit', async function (e) {
          const form = e.target;
          if (!isDeluxeForm(form)) return;

          // Prevent the default form submission and stop all other handlers
          e.preventDefault();
          e.stopImmediatePropagation();

          await handleDeluxeAdd(form);
        }, true);

        console.log('[Feb Love] Form intercept enabled for collection page quick-add');
      }
    }

    const promos = new FebruaryLovePromos();
    promos.init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["march-2026-promos"] && !Shopify.designMode) return;
  try {
    /* March 2026 cart promo banner
     - No logic
     - No cart mutations
     - Only injects static banner inside Rebuy Smart Cart
     - Persists through cart updates
  */

  (() => {
    if (window.__MarchPromoBannerInit) return;
    window.__MarchPromoBannerInit = true;
    let subtotal = 0;
    const MESSAGE = 'Choose your free gift';

    class MarchPromoBanner {
      constructor() {
        this.rootEl = null;
        this.observer = null;
        this.renderTimeout = null;
        this.init = this.init.bind(this);
        this.render = this.render.bind(this);
        this.debouncedRender = this.debouncedRender.bind(this);
      }

      init() {
        // Listen to Rebuy events
        document.addEventListener('rebuy:smartcart.ready', this.debouncedRender);
        document.addEventListener('rebuy:cart.change', this.debouncedRender);
        
        // Initial render
        this.waitForSmartCart();
        
        // Watch for DOM changes that might remove our banner
        this.observeCartChanges();
      }

      debouncedRender(e) {
        const eventTotal = e?.detail?.cart?.cart?.total_price;
        if (typeof eventTotal === 'number') {
          subtotal = eventTotal / 100;
        }

        clearTimeout(this.renderTimeout);
        this.renderTimeout = setTimeout(() => {
          this.render();
        }, 50);
      }

      waitForSmartCart() {
        let attempts = 0;
        const maxAttempts = 50;
        
        const interval = setInterval(() => {
          attempts++;
          const anchor = this.getAnchorElement();
          
          if (anchor) {
            clearInterval(interval);
            this.render();
          }
          
          if (attempts >= maxAttempts) {
            clearInterval(interval);
          }
        }, 200);
      }

      getAnchorElement() {
        return (
          document.querySelector('ul[data-smartcart-items]') ||
          document.querySelector('.rebuy-widget.widget-type-cart.widget-display-popup .rebuy-cart__items-wrapper')
        );
      }

      observeCartChanges() {
        // Disconnect existing observer if any
        if (this.observer) {
          this.observer.disconnect();
        }

        // Create a new observer to watch for DOM changes
        this.observer = new MutationObserver((mutations) => {
          // Check if our banner was removed
          if (this.rootEl && !document.body.contains(this.rootEl)) {
            this.debouncedRender();
            return;
          }

          // Check if cart items list appeared/changed
          for (const mutation of mutations) {
            if (mutation.addedNodes.length > 0) {
              const hasCartItems = Array.from(mutation.addedNodes).some(node => {
                return node.nodeType === 1 && (
                  node.matches?.('ul[data-smartcart-items]') ||
                  node.querySelector?.('ul[data-smartcart-items]')
                );
              });
              
              if (hasCartItems) {
                this.debouncedRender();
                break;
              }
            }
          }
        });

        // Start observing
        this.observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }

      ensureRoot() {
        const anchor = this.getAnchorElement();
        if (!anchor) return null;
        // Create root element if it doesn't exist
        if (!this.rootEl || !document.body.contains(this.rootEl)) {
          this.rootEl = document.createElement('div');
          this.rootEl.className = 'march-promo-banner';
          this.rootEl.setAttribute('data-march-promo-banner', 'true');
        }

        // Preferred placement: right above cart items list
        if (anchor.matches && anchor.matches('ul[data-smartcart-items]') && anchor.parentElement) {
          if (this.rootEl.parentElement !== anchor.parentElement || this.rootEl.nextElementSibling !== anchor) {
            this.rootEl.remove();
            anchor.before(this.rootEl);
          }
          return this.rootEl;
        }

        // Fallback placement
        if (!anchor.contains(this.rootEl)) {
          // Try to insert at the beginning
          if (anchor.firstChild) {
            anchor.insertBefore(this.rootEl, anchor.firstChild);
          } else {
            anchor.appendChild(this.rootEl);
          }
        }

        return this.rootEl;
      }

      render() {
        if( subtotal < 150){
          if(this.rootEl){
            this.rootEl.remove();
            this.rootEl = null;
          }
          return;
        }
        const root = this.ensureRoot();
        if (!root) return;
        let expectedHTML = '';

        if (subtotal >= 150 && subtotal < 175) {
          expectedHTML = `
          <div class="march-promo-banner__block" role="region" aria-label="Pre Promo message">
            <p class="march-promo-banner__message">You are almost there! spend $175 and you can choose a free full size Daily Essential for free!</p>   
          </div>
        `.trim();
        }
        else{
          expectedHTML = `
          <div class="march-promo-banner__block" role="region" aria-label="Promo message">
            <p class="march-promo-banner__message">${MESSAGE}</p>
              <button
            type="button"
            class="march-promo__btn"
            aria-label="Add Free Product with March Promo"
          >
            ADD
          </button>
          </div>
        `.trim();
        }
        // Only update innerHTML if it's not already set
        // This prevents unnecessary re-renders
       

        if (root.innerHTML.trim() !== expectedHTML) {
          root.innerHTML = expectedHTML;
        }
      }
    }

    new MarchPromoBanner().init();
  })();
  } catch(e) { console.error(e); }
})();

})();
